"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BookAppointmentCta = exports.ProviderSpecialtiesMoreAnchor = exports.ProviderCompactFirstSpecialty = exports.ProviderSpecialtiesContent = exports.ProviderSpecialtiesContainer = exports.ProviderNameLinkContainer = exports.ProviderNameContainer = exports.MapProviderImage = exports.ImageWrapperWithEnhancement = exports.ImageWrapper = exports.MapProviderContentWrapper = exports.MapProviderRowContainer = exports.MapProviderCardContainer = void 0;
const styled_1 = __importDefault(require("@emotion/styled"));
const ui_theme_1 = require("@kyruus/ui-theme");
const image_component_1 = __importDefault(require("@kyruus/image-component"));
const button_1 = require("@kyruus/button");
const COMPACT_PROVIDER_IMAGE_SIZE = '40px';
exports.MapProviderCardContainer = (0, styled_1.default)('div') `
  display: flex;
  flex-direction: column;
  gap: ${(0, ui_theme_1.fromTheme)('spacing_small')};
  width: 100%;
  color: ${(0, ui_theme_1.fromTheme)('color_text')};
`;
exports.MapProviderRowContainer = (0, styled_1.default)('div') `
  display: flex;
  align-items: flex-start;
  gap: ${(0, ui_theme_1.fromTheme)('spacing_medium')};
  width: 100%;
`;
exports.MapProviderContentWrapper = (0, styled_1.default)('div') `
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
  font-size: ${(0, ui_theme_1.fromTheme)('font_size')};
  font-weight: ${(0, ui_theme_1.fromTheme)('font_weight_bold')};
`;
exports.ImageWrapper = (0, styled_1.default)('div') `
  height: ${COMPACT_PROVIDER_IMAGE_SIZE};
  width: ${COMPACT_PROVIDER_IMAGE_SIZE};
  flex-shrink: 0;
  overflow: hidden;
  border: ${(0, ui_theme_1.fromTheme)('border_width')} ${(0, ui_theme_1.fromTheme)('border_style')}
    ${(0, ui_theme_1.fromTheme)('color_border')};
  background: ${(0, ui_theme_1.fromTheme)('color_image_placeholder')};
  border-radius: 50%;
`;
exports.ImageWrapperWithEnhancement = (0, styled_1.default)('div') `
  flex-shrink: 0;
  img {
    border: ${(0, ui_theme_1.fromTheme)('border_width')} ${(0, ui_theme_1.fromTheme)('border_style')}
      ${(0, ui_theme_1.fromTheme)('color_border')};
    border-radius: 50%;
  }
`;
exports.MapProviderImage = (0, styled_1.default)(image_component_1.default) `
  display: block;
  max-width: ${({ enabledEnhancement }) => enabledEnhancement ? 'unset' : COMPACT_PROVIDER_IMAGE_SIZE};
  width: ${({ enabledEnhancement }) => enabledEnhancement ? COMPACT_PROVIDER_IMAGE_SIZE : '100%'};
  height: ${({ enabledEnhancement }) => enabledEnhancement ? COMPACT_PROVIDER_IMAGE_SIZE : 'auto'};
  border-radius: 50%;

  @media only screen and (min-width: ${(0, ui_theme_1.fromTheme)('screen_medium')}) {
    max-width: ${({ enabledEnhancement }) => enabledEnhancement ? 'unset' : '70px'};
  }
`;
exports.ProviderNameContainer = (0, styled_1.default)('div') `
  font-size: ${(0, ui_theme_1.fromTheme)('font_size')};
  font-weight: ${(0, ui_theme_1.fromTheme)('font_weight_bold')};
  color: ${(0, ui_theme_1.fromTheme)('color_link')};
  line-height: normal;
`;
exports.ProviderNameLinkContainer = (0, styled_1.default)('a') `
  font-size: ${(0, ui_theme_1.fromTheme)('font_size')};
  font-weight: ${(0, ui_theme_1.fromTheme)('font_weight_bold')};
  color: ${(0, ui_theme_1.fromTheme)('color_link')};
  cursor: pointer;
  text-decoration: none;
  line-height: normal;

  &:visited {
    color: ${(0, ui_theme_1.fromTheme)('color_link')};
  }

  &:hover,
  &:hover:visited {
    color: ${(0, ui_theme_1.fromTheme)('color_link_hover')};
    text-decoration: underline;
  }
`;
exports.ProviderSpecialtiesContainer = (0, styled_1.default)('div') `
  color: ${(0, ui_theme_1.fromTheme)('color_text')};
  font-size: ${(0, ui_theme_1.fromTheme)('font_size_small')};
`;
exports.ProviderSpecialtiesContent = (0, styled_1.default)('div') `
  display: flex;
  flex: auto;
`;
exports.ProviderCompactFirstSpecialty = (0, styled_1.default)('div') `
  padding-left: 1px;
  white-space: break-spaces;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: ${(0, ui_theme_1.fromTheme)('font_size')};
  font-weight: ${(0, ui_theme_1.fromTheme)('font_weight')};
  line-height: normal;
`;
exports.ProviderSpecialtiesMoreAnchor = (0, styled_1.default)('div') `
  white-space: nowrap;
  & > span {
    padding-bottom: 1px;
    cursor: pointer;
    display: inline-block;
    border-bottom: 1px dotted;
  }

  &::before {
    content: '';
    display: inline-block;
    vertical-align: middle;
    margin-left: ${(0, ui_theme_1.fromTheme)('spacing_small')};
    margin-right: ${(0, ui_theme_1.fromTheme)('spacing_small')};
    height: 2px;
    width: 2px;
    border-radius: 50%;
    background-color: currentColor;
  }
`;
exports.BookAppointmentCta = (0, styled_1.default)(button_1.ButtonLink) `
  display: flex;
  justify-content: center;
  align-items: center;
  align-self: stretch;
  padding: ${(0, ui_theme_1.fromTheme)('spacing_small')} ${(0, ui_theme_1.fromTheme)('spacing_medium')};
  border-radius: ${(0, ui_theme_1.fromTheme)('spacing_small')};
  border: ${(0, ui_theme_1.fromTheme)('border_width')} ${(0, ui_theme_1.fromTheme)('border_style')}
    ${(0, ui_theme_1.fromTheme)('color_border_info')};
  text-align: center;
  line-height: normal;
`;
//# sourceMappingURL=MapProviderCard.styles.js.map